// 银行的类型
export const bankType = ['Bank Transfer', 'Bank']

// 印尼银行的列表
export const bankListID = [
  { text: 'BankBCA', value: 'bca' },
  { text: 'Bank BRI', value: 'bri' },
  { text: 'BANK CIMB NIAGA', value: 'cimb' },
  { text: 'BANK DANAMON INDONESIA', value: 'danamon' },
  { text: 'BANK MEGA', value: 'mega' },
  { text: 'BANK OCBC NISP', value: 'ocbc' },
  { text: 'BANK MANDIRI', value: 'mandiri' },
  { text: 'BANK BNI 46', value: 'bni' },
  { text: 'Bank Tabungan Pensiunan Nasional', value: 'btpn' },
  { text: 'BSI (Bank Syariah Indonesia)', value: 'bsi' },
  { text: 'BANK PERMATA', value: 'permata' },
  { text: 'BANK PANIN', value: 'panin' },
  { text: 'BANK MAYBANK INDONESIA', value: 'maybank' },
  { text: 'HSBC', value: 'hsbc' },
  { text: 'CITIBANK', value: 'citibank' },
  { text: 'ARTOS', value: 'artos' }
]

// 摩洛哥银行的列表（MA）
export const bankListMA = [
  { text: 'Attijariwafa Bank', value: 'Attijariwafa Bank' },
  { text: 'Banque Populaire (BCP)', value: 'Banque Populaire (BCP)' },
  { text: 'BMCE Bank of Africa', value: 'BMCE Bank of Africa' },
  { text: 'Société Générale Maroc', value: 'Société Générale Maroc' },
  { text: 'Crédit du Maroc', value: 'Crédit du Maroc' },
  { text: 'CIH Bank', value: 'CIH Bank' },
  {
    text: 'Banque Centrale Populaire (BCP)',
    value: 'Banque Centrale Populaire (BCP)'
  },
  { text: 'Crédit Agricole du Maroc', value: 'Crédit Agricole du Maroc' },
  { text: 'Al Barid Bank', value: 'Al Barid Bank' },
  {
    text: "BMCI (Banque Marocaine pour le Commerce et l'Industrie)",
    value: "BMCI (Banque Marocaine pour le Commerce et l'Industrie)"
  },
  {
    text: 'آخر',
    value: 'آخر'
  }
]

// 越南(VN)银行列表
export const bankListVN = [
  { text: 'TechcomBank', value: 'TechcomBank' },
  { text: 'SacomBank', value: 'SacomBank' },
  { text: 'Vietcombank', value: 'Vietcombank' },
  { text: 'Asia Commercial Bank (ACB)', value: 'ACB' },
  { text: 'DongA Bank', value: 'DongABank' },
  { text: 'VietinBank', value: 'VietinBank' },
  { text: 'BIDV', value: 'BIDV' },
  { text: 'EximBank', value: 'EximBank' },
  { text: 'CIMB', value: 'CIMB' },
  { text: 'Vietnam Prosperity Joint Stock Commercial Bank (VPBank)', value: 'VPBank' },
  { text: 'Military Commercial Joint Stock Bank (MB Bank)', value: 'MBBank' },
  { text: 'Tien Phong Commercial Joint Stock Bank (TPBank)', value: 'TPBank' },
  { text: 'AgriBank', value: 'AgriBank' },
  { text: 'LienVietPostBank', value: 'LienVietPostBank' },
  { text: 'Saigon–Hanoi Commercial Joint Stock Bank (SHB)', value: 'SHB' },
  { text: 'Vietnam Public Joint Stock Commercial Bank (PVcomBank)', value: 'PVcomBank' },
  { text: 'Saigon Bank', value: 'SaigonBank' },
  { text: 'Southeast Asia Commercial Joint Stock Bank (SeABank)', value: 'SeABank' },
  { text: 'ABBank', value: 'ABBank' },
  { text: 'Bac A Bank', value: 'BacABank' },
  { text: 'Viet Capital Bank', value: 'VietCapitalBank' },
  { text: 'MSB', value: 'MSB' },
  { text: 'Kien Long Bank', value: 'KienLongBank' },
  { text: 'Nam A Bank', value: 'NamABank' },
  { text: 'NCB', value: 'NCB' },
  { text: 'HDBank', value: 'HDBank' },
  { text: 'Orient Commercial Joint Stock Bank (OCB)', value: 'OCB' },
  { text: 'Vietnam International Commercial Joint Stock Bank (VIB)', value: 'VIB' },
  { text: 'Sai Gon Joint Stock Commercial Bank (SCB)', value: 'SCBank' },
  { text: 'Saigon Bank for Industry and Trade', value: 'Saigon_Bank_for_Industry_and_Trade' },
  { text: 'Viet A Bank', value: 'VietABank' },
  { text: 'Bao Viet Bank', value: 'BaoVietBank' },
  { text: 'Viet Bank', value: 'VietBank' },
  { text: 'PGBank', value: 'PGBank' },
  { text: 'Ocean Bank', value: 'OceanBank' },
  { text: 'GP Bank', value: 'GPBank' },
  { text: 'Shinhan Bank', value: 'ShinhanBank' },
  { text: 'Vietnam Development Bank (VDB)', value: 'Vietnam_Development_Bank' },
  { text: 'ABC Bank Vietnam', value: 'ABCVN' },
  { text: 'ANZ Bank', value: 'ANZBank' },
  { text: 'Commonwealth Bank', value: 'BANKCOMMB' },
  { text: 'CAKE', value: 'CAKE' },
  { text: 'CBBank', value: 'CBBank' },
  { text: 'Citi Bank', value: 'Citibank' },
  { text: 'CoopBank', value: 'CoopBank' },
  { text: 'DBS Bank', value: 'DBSBank' },
  { text: 'DeutscheBank', value: 'DeutscheBank' },
  { text: 'IBK Bank Vietnam', value: 'IBK_Bank' },
  { text: 'KBank Vietnam', value: 'KBank' },
  { text: 'Standard Chartered Bank Vietnam', value: 'StandardChartered' },
  { text: 'United Overseas Bank (UOB) Vietnam', value: 'UBank' },
  { text: 'UnitedOverseas', value: 'UnitedOverseas' },
  { text: 'Vietnam Bank for Social Policies (VBSP)', value: 'VBSP' },
  { text: 'Woori Bank Vietnam', value: 'Woori' },
  { text: 'HSBC Bank Vietnam', value: 'VN_HSBC' }
]

// 哥伦比亚的列表1
export const columbiaList1 = [
  { text: 'Cédula de Identidad', value: '00' },
  { text: 'Cédula de Identidad de Extranjero', value: '01' }
]

// 哥伦比亚的列表2
export const columbiaList2 = [
  { text: 'Cuenta Corriente', value: '00' },
  { text: 'Cuenta de Ahorros', value: '01' }
]
